import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import LoginGate from './components/LoginGate';
import Header from './components/Header';
import HomePage from './pages/HomePage';
import UserDashboard from './pages/UserDashboard';
import AboutPage from './pages/AboutPage';
import TeamPage from './pages/TeamPage';
import ServicesPage from './pages/ServicesPage';
import AnalyticsPage from './pages/AnalyticsPage';
import InsightsPage from './pages/InsightsPage';
import ContactPage from './pages/ContactPage';
import ClientAccessPage from './pages/ClientAccessPage';
import NotFoundPage from './pages/NotFoundPage';
import './App.css';

// Main App Component with Authentication Check
const AppContent = () => {
  const { isAuthenticated, isLoading, login } = useAuth();

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen bg-primary-900 flex items-center justify-center">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="text-center"
        >
          <div className="w-16 h-16 bg-gradient-to-br from-accent-blue to-accent-gold rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
            <span className="text-white font-bold text-2xl">V</span>
          </div>
          <div className="w-8 h-8 border-4 border-accent-blue/30 border-t-accent-blue rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-cream-200">Loading Valeon Platform...</p>
        </motion.div>
      </div>
    );
  }

  return (
    <Router>
      <div className="App min-h-screen bg-primary-900">
        <AnimatePresence>
          {!isAuthenticated ? (
            <LoginGate onLogin={login} />
          ) : (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
            >
              <Header />
              <motion.main
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.8 }}
              >
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/dashboard" element={<UserDashboard />} />
                  <Route path="/about" element={<AboutPage />} />
                  <Route path="/team" element={<TeamPage />} />
                  <Route path="/services" element={<ServicesPage />} />
                  <Route path="/analytics" element={<AnalyticsPage />} />
                  <Route path="/analytics/*" element={<AnalyticsPage />} />
                  <Route path="/insights" element={<InsightsPage />} />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="/client-access" element={<ClientAccessPage />} />
                  {/* 404 Fallback - Must be last */}
                  <Route path="*" element={<NotFoundPage />} />
                </Routes>
              </motion.main>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </Router>
  );
};

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;